// src/components/layout/Footer.jsx
import { useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import logo from '../../Assets/Logo/SridharFooterlogo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { pathname, key } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTo(0, 0);
    document.body.scrollTo(0, 0);
    const mainContent = document.querySelector('main') || document.querySelector('#root');
    if (mainContent) mainContent.scrollTo(0, 0);
  }, [pathname, key]);

  const activeClass = ({ isActive }) => 
    isActive 
      ? "text-blue-400 underline underline-offset-2 decoration-2 transition-all duration-300" 
      : "text-slate-400 hover:text-blue-400 transition-all duration-300";

  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="container mx-auto px-6 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3 lg:grid-cols-5 lg:gap-8 xl:gap-12">
          
          <div className="flex flex-col">
            {/* LOGO LINK START */}
            <Link to="/" className="mb-6 block transition-all duration-300 hover:opacity-80">
                <img src={logo} alt="Dr. Sridhar Logo" className="h-14 w-auto object-contain" />
            </Link>
            {/* LOGO LINK END */}
            
            <p className="text-slate-400 leading-relaxed mb-6 max-w-md">
              Sridhar International Dental Hospitals – Restoring confident smiles since 1995. 
              Advanced technology, compassionate experts, and personalized care for every generation.
            </p>
            <div className="flex items-center gap-5">
              <a href="https://www.facebook.com/sridhardental/" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-blue-400 transition-colors duration-300 text-xl"><i className="fab fa-facebook-f"></i></a>
              <a href="https://www.instagram.com/dr.sridharreddy_arumalla?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-pink-400 transition-colors duration-300 text-xl"><i className="fab fa-instagram"></i></a>
              {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-blue-300 transition-colors duration-300 text-xl"><i className="fab fa-twitter"></i></a> */}
              <a href="https://www.linkedin.com/company/dr-sridhar-international-dental-hospital-&-research-centre/?originalSubdomain=in" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-blue-500 transition-colors duration-300 text-xl"><i className="fab fa-linkedin-in"></i></a>
              <a 
  href="https://www.youtube.com/@DrARUMALLASRIDHARREDDY" 
  target="_blank" 
  rel="noopener noreferrer" 
  className="text-slate-400 hover:text-red-500 transition-colors duration-300 text-xl"
>
  <i className="fab fa-youtube"></i>
</a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div className="flex flex-col">
            <h4 className="text-lg font-semibold text-white mb-5 pb-2 border-b border-blue-700/50 inline-block">
              Quick Links
            </h4>
            <ul className="space-y-3 flex flex-col">
              <li><NavLink to="/about" className={activeClass}>About Us</NavLink></li>
              <li><NavLink to="/services" className={activeClass}>Our Services</NavLink></li>
              <li><NavLink to="/gallery" className={activeClass}>Gallery</NavLink></li>
              <li><NavLink to="/blog" className={activeClass}>Our Blog</NavLink></li>
              <li><NavLink to="/contact" className={activeClass}>Contact Us</NavLink></li>
            </ul>
          </div>

          {/* Column 3 - Our Services */}
          <div className="flex flex-col">
            <h4 className="text-lg font-semibold text-white mb-5 pb-2 border-b border-blue-700/50 inline-block">
              Our Services
            </h4>
            <ul className="space-y-3 flex flex-col text-sm">
              <li><NavLink to="/service/smile-Designing" className={activeClass}>Smile Designing & Cosmetic Dentistry</NavLink></li>
              <li><NavLink to="/service/dental-implants" className={activeClass}>Dental Implants</NavLink></li>
              <li><NavLink to="/service/periodontal-treatment" className={activeClass}>Periodontal Treatment</NavLink></li>
              <li><NavLink to="/service/laser-dentistry" className={activeClass}>Laser Dentistry</NavLink></li>
              <li><NavLink to="/service/root-canal" className={activeClass}>Root Canal (Endodontics)</NavLink></li>
              <li><NavLink to="/service/oral-surgery" className={activeClass}>Oral & Maxillofacial Surgery</NavLink></li>
              <li><NavLink to="/service/pediatric-dentistry" className={activeClass}>Pediatric Dentistry</NavLink></li>
              <li><NavLink to="/service/crownsBridges-dentures" className={activeClass}>Crowns, Bridges & Dentures</NavLink></li>
              <li><NavLink to="/service/invisalign" className={activeClass}>Orthodontics</NavLink></li>
              <li><NavLink to="/service/advanced-dentures" className={activeClass}>Advanced Denture Solutions</NavLink></li>
              <li><NavLink to="/service/radiology-department" className={activeClass}>Dental Radiology & Diagnostics</NavLink></li>
            </ul>
          </div>

          {/* Column 4 - Support */}
<div className="flex flex-col">
  <h4 className="text-lg font-semibold text-white mb-5 pb-2 border-b border-blue-700/50 inline-block">
    Support
  </h4>
  <ul className="space-y-3 flex flex-col">
    <li><NavLink to="/case-study" className={activeClass}>Case Studies</NavLink></li>
    <li><NavLink to="/doctor-team" className={activeClass}>Our Doctors</NavLink></li>
    <li>
      <NavLink
        to="/faq"
        className={activeClass}
      >
        FAQ
      </NavLink>
    </li>
    <li><NavLink to="/take-a-tour" className={activeClass}>Take A Tour</NavLink></li>
  </ul>
</div>
          {/* Column 5 - Contact */}
          <div className="flex flex-col">
            <h4 className="text-lg font-semibold text-white mb-5 pb-2 border-b border-blue-700/50 inline-block">
              Get in Touch
            </h4>
            <div className="space-y-5 mb-8">
              <div className="flex items-start gap-3">
                <span className="text-blue-400 text-2xl flex-shrink-0">📍</span>
                <p className="leading-relaxed">
                  Vijayawada • Hyderabad<br />
                  <span className="text-slate-500 text-sm">(Main branches in AP & TS)</span>
                </p>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-blue-400 text-2xl flex-shrink-0">📞</span>
                <div className="flex flex-col text-sm">
                  <a href="tel:+919490948081" className="hover:text-blue-400">+91 94909 48081</a>
                  <a href="tel:+919542027700" className="hover:text-blue-400">+91 95420 27700</a>
                </div>
              </div> 
              <div className="flex items-center gap-3">
                <span className="text-blue-400 flex-shrink-0">✉️</span>
                <a href="mailto:dr.sridhardental@gmail.com" className="hover:text-blue-400 text-[10px] lg:text-[14px]">dr.sridhardental@gmail.com</a>
              </div>
            </div>
          </div>
        </div>
      </div>
       
      <div className="bg-black/60 py-6 text-center text-sm border-t border-slate-800 space-y-2">
        <p className="text-slate-400">
          © {currentYear} DR. SRIDHAR International Dental Hospitals – All rights reserved
        </p>
        <p className="text-slate-400">
          Specialized Dental Care | Designed & Developed by Oakya IT Services Pvt Ltd
        </p>
      </div>
    </footer>
  );
};

export default Footer;